export default {"src":"/_next/static/media/linkedin.cb2fa6be.svg","height":48,"width":48};